import { FunctionComponent, useEffect, useState, useCallback } from "react";
import "./Success.css";

const Img: FunctionComponent<{ src: string }> = ({ src }) => (
  <div>
    <img src={src} />
  </div>
);

interface SuccessProps {
  setStyle: (style: React.CSSProperties) => void;
}

export const Success: FunctionComponent<SuccessProps> = ({ setStyle }) => {
  const [step, setStep] = useState(0);
  const lastStep = 3;
  const nextStep = useCallback(
    () => setStep((current) => current + 1),
    [setStep]
  );
  useEffect(() => {
    switch (step) {
      case 0:
        setStyle({
          background: "#81c8fe",
        });
        break;
      case 1:
        setStyle({
          background: "#4d4d4d",
          color: "hsla(0,0%,100%,0.76)",
        });
        break;
      case 2:
        setStyle({
          background: "#1d1c1f",
          color: "hsla(0,0%,100%,0.76)",
        });
        break;
      case 3:
        setStyle({
          background: "#fef100",
        });
    }
  }, [setStyle, step]);
  const nextButton =
    step < lastStep ? <button onClick={nextStep}>Suivant</button> : null;

  return (
    <div className="Success">
      {step === 0 && (
        <div>
          <Img src={process.env.PUBLIC_URL + "/envoi-en-cours.gif"} />
          {nextButton}
        </div>
      )}
      {step === 1 && (
        <div>
          <h1>Le scandale est dévoilé !</h1>
          <Img src={process.env.PUBLIC_URL + "/presse-journal.webp"} />
          {nextButton}
        </div>
      )}
      {step === 2 && (
        <div className="black">
          <div className="three-columns">
            <img src={process.env.PUBLIC_URL + "/fireworks.gif"} />
            <div>
              <h1>
                L'entreprise doit arreter de déverser des déchets toxiques
              </h1>
              <h1>Les animaux sont sauvés</h1>
            </div>
            <img src={process.env.PUBLIC_URL + "/fireworks.gif"} />
          </div>
          {nextButton}
        </div>
      )}
      {step === 3 && (
        <div>
          <h1>Vous avez mérité un bon goûter !</h1>
          <Img src={process.env.PUBLIC_URL + "/gouter.webp"} />
          {nextButton}
        </div>
      )}
    </div>
  );
};
